import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OyanUiRoutingConstants } from '../../oyan-ui.router.constants';
import { AdminUsersComponent } from './containers/admin-users/admin-users.component';
import { UserProfileShellComponent } from './containers/user-profile-shell/user-profile-shell.component';

import { fromAdminBusinessProfiles } from '@iot-platform/iot4bos/ui/backoffice';

const routes: Routes = [
  { path: '', redirectTo: OyanUiRoutingConstants.USERS, pathMatch: 'full' },
  {
    path: OyanUiRoutingConstants.USERS,
    component: AdminUsersComponent,
    providers: [fromAdminBusinessProfiles.provideBusinessProfilesState(), fromAdminBusinessProfiles.provideBusinessProfilesMembersState()]
  },
  {
    path: OyanUiRoutingConstants.PROFILE,
    component: UserProfileShellComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRouterModule {}
